import Block from './Block'
import DataTable from 'datatables.net-dt'
import createDocumentation from '../anims/Documentation'
import store from '../util/store'

export default class Contact extends Block {
  getElems() {
    this.tables = Array.from(this.el.querySelectorAll('.c-table-products'))
    this.documentations = Array.from(this.el.querySelectorAll('.c-documentation'))
  }

  init() {
    if (this.tables) {
      this.tables.forEach((table) => {
        this._createTable(table)

        const head = table.querySelector('thead')

        head.addEventListener('mouseenter', () => {
          store.cursor.addState('-m')
          store.cursor.setIcon('resources--assets--images--svg--sort-white')
        })

        head.addEventListener('mouseleave', () => {
          store.cursor.removeState('-m')
          store.cursor.removeIcon()
        })
      })
    }

    if (this.documentations) {
      this.documentations.forEach((documentation) => {
        createDocumentation(documentation)
      })
    }
  }

  events() {
  }

  _createTable(table) {
    return new DataTable(table, {
      searching: false,
      responsive: true,
      ordering: false
    })
  }
}
